import { Link } from 'react-router-dom';

// project-import
import { APP_DEFAULT_PATH } from 'config';
import branding from 'branding.json';

export const DrawerHeader = () => {
  return (
    <div className="m-header">
      <Link to={APP_DEFAULT_PATH} className="b-brand text-white">
        <span className="logo logo-lg fw-bold fs-4">{branding.brandName}</span>
      </Link>
    </div>
  );
};
